import { useState } from 'react';
import { useDatos } from '../datos/DatosContext';
import { useAviso } from '../lib/avisos';
import { nuevoId } from '../lib/fechas';
import { Icono } from '../componentes/ui/Icono';
import { Cabecera, Demo } from '../componentes/ui/basicos';

export function EspacioLibre() {
  const { datos, agregar } = useDatos();
  const aviso = useAviso();
  const [titulo, setTitulo] = useState('');

  const crear = () => {
    const t = titulo.trim();
    if (!t) { aviso('Ponle un título a la página.'); return; }
    agregar('libre', { id: nuevoId('f'), titulo: t, meta: 'Página libre · nueva', icono: 'file' });
    setTitulo('');
    aviso('Página creada (solo en esta sesión).');
  };
  const soloVisual = () => aviso('Solo visual: subir archivos y guardar enlaces llegará con la conexión real.');

  return (
    <div className="stack-lg">
      <Cabecera antetitulo="Mi rincón sin reglas" titulo="Espacio libre" subtitulo="No hace falta clasificar todo." />
      <div className="card stack-sm">
        <label className="lbl" htmlFor="free">Nueva página libre</label>
        <div className="composer">
          <input id="free" type="text" placeholder="Título de la página" value={titulo} onChange={(e) => setTitulo(e.target.value)} />
          <button className="btn primary" onClick={crear}>Crear</button>
        </div>
        <div className="row">
          <button className="btn quiet small" onClick={soloVisual}><Icono nombre="file" tam="sm" />Subir archivo <Demo /></button>
          <button className="btn quiet small" onClick={soloVisual}><Icono nombre="link" tam="sm" />Guardar enlace <Demo /></button>
        </div>
      </div>
      <div className="free-grid">
        {datos.libre.map((f) => (
          <button key={f.id} className="tile" onClick={() => aviso('Solo visual: aquí se abrirá «' + f.titulo + '» (en la app real, desde tu Notion).')}>
            <span className="qicon"><Icono nombre={f.icono} /></span>
            <span style={{ fontWeight: 600 }}>{f.titulo}</span>
            <span className="muted small">{f.meta}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
